import { sortBy } from 'lodash';
import find from 'lodash/find';
import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import React from 'react';
import { Select } from '../../../../base-components/Select';
import { OrgForm } from '../../../../types/entities';

interface OrgFormOption {
    value: number;
    label: string;
    group: string;
}

interface GroupedOrgFormOption {
    label: string;
    options: OrgFormOption[];
}

interface Props {
    instanceId: string;
    orgForms: OrgForm[];
    value: OrgForm | null;
    onChange: (value: OrgForm | null) => void;
    className?: string;
    isDisabled?: boolean;
}

/**
 * Селектор организационно-правовой формы
 */
export const SelectOrgForm: React.FC<Props> = ({
    instanceId,
    orgForms,
    value: externalValue,
    onChange: externalOnChange,
    className,
    isDisabled,
}) => {
    const options: OrgFormOption[] = map(
        sortBy(orgForms, ['displayGroup', 'displaySort']),
        (orgForm) => ({
            value: orgForm.id,
            label: orgForm.abbrev
                ? `${orgForm.name} (${orgForm.abbrev})`
                : orgForm.name,
            group: orgForm.displayGroup === 1 ? 'Основные' : 'Дополнительные',
        })
    );

    const groupedOptions: GroupedOrgFormOption[] = map(
        groupBy(options, 'group'),
        (grouped, group) => ({
            label: group,
            options: grouped,
        })
    );

    const selectValue: OrgFormOption | null = externalValue
        ? find(options, ['value', externalValue.id]) || null
        : null;

    const handleChange = (selectedOption: OrgFormOption | null) => {
        const selectedBlock: OrgForm | null = selectedOption
            ? find(orgForms, ['id', selectedOption.value]) || null
            : null;
        externalOnChange?.(selectedBlock);
    };

    return (
        <Select
            instanceId={instanceId}
            placeholder="Организационно-правовая форма"
            value={selectValue}
            onChange={handleChange}
            options={groupedOptions}
            className={className}
            isMulti={false}
            isSearchable={true}
            isDisabled={isDisabled}
        />
    );
};
